<app-component-header></app-component-header>
<!-- Dashboard -->
<section class="padd-top">
    <div class="container">
        <div class="pt-1">
            <div class="spinner-border text-primary" role="status" [hidden]="isSendingData">
                <span class="sr-only">Loading...</span>
            </div>
            <div class="spinner-align" [hidden]="isSendingData"></div>
            <div class="row">
                <div class="col-lg-8 col-md-8">
                    <!--head-->
                    <div class="row-full">
                        <div class="text-head">BIỂU MẪU TRỰC TUYẾN</div>
                    </div>
                    <!--end-->
                    <div class="container">
                        <nz-form-control [formGroup]="homeForm" [hidden]="">
                            <!--form-->
                            <div class="row ">
                                <div class="form-group col-lg-6">
                                    <div class="md-input">
                                        <nz-form-label nzNoColon>
                                            <span>Họ tên khách hàng <span style="color:red;">(*)</span></span>
                                        </nz-form-label>
                                        <input style="text-transform: uppercase;" nz-input type="text"
                                            maxlength="maxlength" nzSize="large" required="true"
                                            formControlName="customerName"
                                            (change)="checkChanges($event)">
                                    </div>
                                </div>
                                <div class="form-group col-lg-6">
                                    <div class="md-input">
                                        <nz-form-label nzNoColon>
                                            <span>Chức vụ <span style="color:red;">(*)</span></span>
                                        </nz-form-label>
                                        <nz-select class=" directive-component" nzShowSearch nzAllowClear
                                            nzPlaceHolder="Chức vụ" nzSize="large" style="width: 100%"
                                            formControlName="positions"
                                            (ngModelChange)="checkChanges($event)">
                                            <nz-option *ngFor="let item of positions" [nzLabel]="item.dataTextField"
                                                [nzValue]="item" nzSize="large"></nz-option>
                                        </nz-select>
                                    </div>
                                </div>
                            </div>
                            <!-- end form -->
                            <!--form-->
                            <div class="row ">
                                <div class="form-group col-lg-6">
                                    <div class="md-input">
                                        <nz-form-label nzNoColon>
                                            <span>Số điện thoại <span style="color:red;">(*)</span></span>
                                        </nz-form-label>
                                        <input nz-input type="text" pattern="(84|0[1-9])+([0-9]{8})\b" maxlength="10"
                                            nzSize="large" required="true" formControlName="phone"
                                            (change)="checkChanges($event)">
                                    </div>
                                </div>
                                <div class="form-group col-lg-6">
                                    <div class="md-input">
                                        <nz-form-label nzNoColon>
                                            <span>Địa chỉ Email <span style="color:red;">(*)</span></span>
                                        </nz-form-label>
                                        <input nz-input type="text" maxlength="maxlength" nzSize="large" required="true"
                                            formControlName="email" (blur)="checkValidEmail()"
                                            (change)="checkChanges($event)">
                                    </div>
                                </div>

                            </div>
                            <!-- end form -->
                            <!--form-->
                            <div class="row ">
                                <div class="form-group col-lg-12">
                                    <div class="md-input">
                                        <nz-form-label nzNoColon>
                                            <span>Tên công ty <span style="color:red;">(*)</span></span>
                                        </nz-form-label>
                                        <input nz-input type="text" style="text-transform: uppercase;" nzSize="large"
                                            required="true" formControlName="companyName"
                                            (change)="checkChanges($event)">
                                    </div>
                                </div>
                            </div>
                            <!-- end form -->
                            <!--form-->
                            <div class="row ">
                                <div class="form-group col-lg-12">
                                    <div class="md-input">
                                        <nz-form-label nzNoColon>
                                            <span>Số GCN ĐKKD/GCN ĐKDN/QĐ thành lập/GCN ĐKĐT <span
                                                    style="color:red;">(*)</span></span>
                                        </nz-form-label>
                                        <input nz-input type="text" style="text-transform: uppercase;" nzSize="large"
                                            required="true" formControlName="taxCode"
                                            (change)="checkChanges($event)">
                                    </div>
                                </div>
                            </div>
                            <!-- end form -->
                            <!--form-->
                            <div class="row ">
                                <div class="form-group col-lg-6">
                                    <div class="md-input">
                                        <nz-form-label nzNoColon>
                                            <span>Tỉnh/ Thành phố <span style="color:red;">(*)</span></span>
                                        </nz-form-label>
                                        <nz-select class="" nzShowSearch nzAllowClear nzPlaceHolder="Tỉnh/ Thành phố"
                                            (ngModelChange)="changeProvince($event); checkChanges($event)" nzSize="large" style="width: 100%"
                                            formControlName="provinces">
                                            <nz-option *ngFor="let item of provinces" [nzLabel]="item.name"
                                                [nzValue]="item" nzSize="large"></nz-option>
                                        </nz-select>
                                    </div>
                                </div>
                                <div class="form-group col-lg-6">
                                    <div class="md-input">
                                        <nz-form-label nzNoColon>
                                            <span>Quận/ Huyện <span style="color:red;">(*)</span></span>
                                        </nz-form-label>
                                        <nz-select class="" nzShowSearch nzAllowClear nzPlaceHolder="Quận/ Huyện"
                                            nzSize="large" style="width: 100%" (ngModelChange)="changeDistrict(); checkChanges($event)"
                                            formControlName="districts">
                                            <nz-option *ngFor="let item of districts" [nzLabel]="item.name"
                                                [nzValue]="item" nzSize="large"></nz-option>
                                        </nz-select>
                                    </div>
                                </div>
                            </div>
                            <!-- end form -->
                            <!--form-->
                            <div class="row ">
                                <div class="form-group col-lg-12">
                                    <div class="md-input">
                                        <nz-form-label nzNoColon>
                                            <span>Đơn vị giao dịch <span style="color:red;">(*)</span></span>
                                        </nz-form-label>
                                        <nz-select class="" nzShowSearch nzAllowClear nzPlaceHolder="Đơn vị giao dịch"
                                            nzSize="large" style="width: 100%" (ngModelChange)="changeBranch(); checkChanges($event)"
                                            formControlName="branches">
                                            <nz-option *ngFor="let item of branches" [nzLabel]="item.nameVN"
                                                [nzValue]="item" nzSize="large"></nz-option>
                                        </nz-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row" *ngIf="branchAddress" style="margin-top: -1.25rem !important;">
                                <div class="form-group col-lg-12">
                                    <div class="md-input">
                                        <span><i>Địa chỉ giao dịch: {{branchAddress}}</i></span>
                                    </div>
                                </div>
                            </div>
                            <!-- end form -->
                            <!--form-->
                            <div class="row ">
                                <div class="form-group col-lg-6">
                                    <div class="md-input">
                                        <nz-form-label nzNoColon>
                                            <span>Nhóm sản phẩm dịch vụ <span style="color:red;">(*)</span></span>
                                        </nz-form-label>
                                        <nz-select class="" nzShowSearch nzAllowClear nzPlaceHolder="Nhóm"
                                            nzSize="large" style="width: 100%" (ngModelChange)="changeProductGroups(); checkChanges($event)"
                                            formControlName="productGroups">
                                            <nz-option *ngFor="let item of productGroups" [nzLabel]="item.name"
                                                [nzValue]="item" nzSize="large"></nz-option>
                                        </nz-select>
                                    </div>
                                </div>
                                <div class="form-group col-lg-6">
                                    <div class="md-input">
                                        <nz-form-label nzNoColon>
                                            <span>Sản phẩm dịch vụ <span style="color:red;">(*)</span></span>
                                        </nz-form-label>
                                        <nz-select class="" nzShowSearch nzAllowClear nzPlaceHolder="Sản phẩm"
                                            nzSize="large" style="width: 100%" (ngModelChange)="changeProduct(); checkChanges($event)"
                                            formControlName="products">
                                            <nz-option *ngFor="let item of products" [nzLabel]="item.name"
                                                [nzValue]="item" nzSize="large"></nz-option>
                                        </nz-select>
                                    </div>
                                </div>
                            </div>
                            <!-- end form -->
                            <div class="row ">
                                <div class="col-12">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value=""
                                            style="cursor: pointer;" formControlName="acceptTermsConditions" 
                                            (change)="checkChanges($event)"/>
                                        <label class="form-check-label" for="flexCheckDefault">
                                            Tôi đồng ý cung cấp thông tin và cho phép SACOMBANK sử dụng thông tin theo
                                            các quy định tại
                                            <a href="https://www.sacombank.com.vn/content/dam/sacombank/files/an-toan-bao-mat/DIEU%20KHOAN%20CHUNG%20VE%20BAO%20VE%20VA%20XU%20LY%20DU%20LIEU%20CA%20NHAN.pdf"
                                                target="_blank">Điều khoản chung về bảo vệ và xử lý dữ liệu cá nhân</a>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </nz-form-control>
                    </div>
                    <!--form-->
                    <div class="row my-3">
                        <div class="form-group col-lg-12 text-center">
                            <button #buttonContinue type="button" class="btn btn-checkin" data-bs-toggle="modal"
                                data-bs-target="#exampleModalCenter-authen" (click)="submitForm()"
                                *ngIf="!isLoading">TIẾP TỤC ĐĂNG KÝ</button>
                        </div>
                    </div>
                    <!-- end form -->
                    <div *ngIf="isLoading" class="loading-container">
                        <div class="loading-spin">
                            <ng-template #indicatorTemplate><i nz-icon nzType="loading"></i></ng-template>
                            <nz-spin nzSimple [nzSize]="'large'" [nzIndicator]="indicatorTemplate"></nz-spin>
                        </div>
                    </div>
                </div>
                <!-- icon -->
                <div class="col-lg-4 col-md-4 img-dis">
                    <div class="text-center img-height">
                        <img src="assets/img/img-formonline.jpg" alt="icon" class="img-fluid">
                    </div>
                </div>
                <!-- end icon -->
            </div>
        </div>
    </div>
</section>
<app-component-footer></app-component-footer>